import {findBikeMetaFieldByName} from "../../utility/Helper"
import Typography from "../reusable/Typography/Typography"
import AboutThisBike from "./AboutThisBike"
import BikeDescription from "./productInfo/BikeDescription"
import BikeInfoAndOverview from "./components/BikeInfoAndOverview"
import BikeSpecs from "./components/BikeSpecs"
import BikeSizes from "./productInfo/BikeSizes"
import React from "react"
import ServiceCentersMap from "../serviceCenters/map/ServiceCentersMap"
import Button from "../reusable/components/Button"
import Image from "next/image"
import {GeoAlt} from "react-bootstrap-icons"

const getAccordionContent = (bike: any, isAccessory:boolean, t:(_:string)=>string, handleBookTestdriveClick:()=>void, servicePartners:any[]) => {
	const videoUrl = findBikeMetaFieldByName(bike, "video_url")
	const videoEmbed = videoUrl && videoUrl?.replace("watch?v=", "embed/")?.replace("youtu.be/", "www.youtube.com/embed/")

	return [
		{
			title: "Besonderheiten",
			slug: "overview-tabs",
			titleContent: (
				<Typography variant="heading1Black"
					semanticTag="span">
					{t("Highlights")}
				</Typography>
			),
			content: (
				<div className={"bike-details-tab-panel"}>
					<AboutThisBike bike={bike}
						isForPDP/>
				</div>
			)
		},
		{
			title: "Service Shops",
			slug: "service-shops-tab",
			titleContent: (
				<Typography variant="heading1Black"
					semanticTag="span">
					{t("service-centers-title")}
				</Typography>
			),
			content: (
				<div
					className="col-12 mt-3 mb-4">
					<ServiceCentersMap
						isPdp
						mapApiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}
						servicePartnersRawList={servicePartners}
					/>
					<div className="d-flex mt-4 align-items-md-center align-items-start gap-3 justify-content-md-between justify-content-start flex-md-row flex-column">
						<Typography variant="bodySmBold"
							style={{fontSize: "16px", lineHeight: "24px", color: "#212529"}}>{t("test-drive-label")}</Typography>
						<Button label={t("test-drive-cta")}
							icon={<Image
								src="/assets/icons/test-drive.svg"
								height={18}
								width={ 18}
								objectFit="contain"
								alt="Test Drive"
							/>}
							color="#000"
							className="col-12 col-md-auto"
							outline
							fontSizeSmall
							iconFirst
							onClick={handleBookTestdriveClick}
						/>
					</div>
					<div className="d-flex mt-2 align-items-center justify-content-start gap-2"><GeoAlt /><Typography variant="bodySm"
						style={{fontSize: "14px", lineHeight: "20px", color: "#212529"}}>Zweierstrasse 100, 8003 Zürich</Typography></div>

				</div>
			)
		},
		{
			title: "Übersicht",
			titleContent: (
				<Typography variant="heading1Black"
					semanticTag="span">
					{t("Übersicht")}
				</Typography>
			),
			content: (
				<div className={"bike-details-tab-panel"}>
					<BikeInfoAndOverview bike={bike}
					/>
				</div>
			)
		},
		{
			title: "Einzelheiten",
			titleContent: (
				<Typography variant="heading1Black"
					semanticTag="span">
					{t("Einzelheiten")}
				</Typography>
			),
			content: (
				<div className={"bike-details-tab-panel"}>
					<BikeSpecs
						bike={bike}/>
				</div>
			)
		},
		{
			title: "Beschreibung",
			titleContent: (
				<Typography variant="heading1Black"
					semanticTag="span">
					{t("Beschreibung")}
				</Typography>),
			content: (
				<div className={"bike-details-tab-panel"}>
					<BikeDescription description={bike?.short_description}/>
				</div>
			)
		},
		{
			title: "Grössenempfehlung",
			titleContent: (
				<Typography variant="heading1Black"
					semanticTag="span">
					{t("Sizes")}
				</Typography>
			),
			content: (
				<div className={"bike-details-tab-panel"}>
					<BikeSizes bike={bike} />
				</div>
			)
		},
		{
			title: "Youtube Videos",
			slug: "youtube-video",
			titleContent: (
				<Typography variant="heading1Black"
					semanticTag="span">
					YouTube Videos
				</Typography>
			),
			content: (
				<div className={"bike-details-tab-panel"}>
					{
						videoEmbed ?
							<div className={"row"}>
								<div className={"col-12 col-lg-6 mt-4 mt-lg-0"}>
									<div className="ratio ratio-16x9">
										<iframe width="560"
											height="315"
											src={videoEmbed}
											title="YouTube video player"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
											allowFullScreen></iframe>
									</div>
								</div>
							</div> :
							null
					}
				</div>
			)
		}

	].filter(item => !(!bike.short_description && item.title === "Beschreibung") && !(isAccessory && item.title === "Besonderheiten"))
}

export default getAccordionContent
